import React from 'react';

import {
  Header,
  IconWrapper,
  LinkHeader,
  NavigationSubtitle,
  SettingsInfo,
  Wrapper
} from './style';
import { CustomLinkProps, Props } from './types';

const CustomLink = ({ disabled, children, href, dataTestId }: CustomLinkProps) => {
  if (disabled) {
    return <Header>{children}</Header>;
  }

  return (
    <LinkHeader data-test-id={dataTestId} to={href}>
      {children}
    </LinkHeader>
  );
};

const NavigationSettingsLink = ({
  icon,
  titleInfo,
  subtitle,
  disabled = false,
  dataTestId
}: Props): JSX.Element => {
  return (
    <Wrapper disabled={disabled}>
      <IconWrapper>{icon}</IconWrapper>
      <SettingsInfo>
        <CustomLink dataTestId={dataTestId} disabled={disabled} href={titleInfo.path}>
          {titleInfo.label}
        </CustomLink>
        <NavigationSubtitle>{subtitle}</NavigationSubtitle>
      </SettingsInfo>
    </Wrapper>
  );
};

export default NavigationSettingsLink;
